module.exports = __webpack_public_path__ + "img/dynamic4.b2fa6846.png";